export default __webpack_public_path__ + "65b64935ac8b0696a020f663f123585d.woff";